import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import React, { Component } from "react";
import checkLogin from "../Utils/checkLogin";
import { blogPlayClientType, defaultPaperPadding, tableRowBackground, url_endpoint } from "../../config";
import request from "superagent";
import authHeader from "../Utils/AuthHeader";
import palette from "../../theme/palette";
import moment from "moment";
import LoaderSpinner from "../../componentes/LoaderSpinner";
import goldMedalIcon from '../../images/icons/gold_medal_icon.svg'
import silverMedalIcon from '../../images/icons/silver_medal_icon.svg'
import bronzeMedalIcon from '../../images/icons/bronze_medal_icon.svg'
import InfoTooltip from "./components/InfoTooltip";

class Ranking extends Component {
    periodsOptions = []
    periodsOptionsLabels = ['Semana Atual', 'Semana Anterior', 'Mês Atual', 'Mês Anterior', 'Todo o período']

    valueToOrderOptions = ["play", "download", 'share_total', "share_facebook", "share_linkedin", "share_twitter", "share_whatsapp"]
    valueToOrderOptionsLabels = ["Reproduções", "Downloads", 'Compartilhamentos Totais', "Compartilhamentos no Facebook", "Compartilhamentos no Linkedin", "Compartilhamentos no Twitter", "Compartilhamentos no Whatsapp"]

    periodsItems = []
    valueToOrderItems = []

    constructor(props) {
        super(props)

        this.props.setTitulo('Ranking (Beta)')

        this.state = {
            client: null,
            loading: false,
            period: null,
            valueToOrder: this.valueToOrderOptions[0],
            lastFetchedValueToOrder: null,
            lifetimeRankingItems: [],
            customRankingItems: [],
            generalDialogOpen: false,
            generalDialogTitle: '',
            generalDialogMessage: '',
        }
    }

    generatePeriodOptions() {
        const now = moment()

        const year = now.year()

        const actualWeek = now.isoWeek();
        const fullActualWeek = actualWeek < 10 ? `0${actualWeek}` : actualWeek
        const lastWeek = moment().subtract(7, 'days').isoWeek();
        const fullLastWeek = lastWeek < 10 ? `0${lastWeek}` : lastWeek;
        const actualMonth = now.month()
        const fullActualMonth = actualMonth < 10 ? `0${actualMonth}` : actualMonth
        const lastMonth = actualMonth == 0 ? 11 : (actualMonth - 1)
        const fullLastMonth = lastMonth < 10 ? `0${lastMonth}` : lastMonth
        const lastMonthYear = actualMonth == 0 ? (year - 1) : year

        this.periodsOptions = [`w${year}${fullActualWeek}`, `w${year}${fullLastWeek}`, `${year}${fullActualMonth}`, `${lastMonthYear}${fullLastMonth}`, 'lifetime']
    }

    async componentDidMount() {
        const clientData = await checkLogin(false)

        this.setState({ loading: true, client: clientData })

        const resInitialRanking = await request.post(url_endpoint + "playerview/getRanking/").set(authHeader()).field('period', 'lifetime').field('valueToOrder', 'play');

        this.generatePeriodOptions()

        for (let i = 0; i < this.periodsOptions.length; i++) {
            this.periodsItems.push(
                <MenuItem value={this.periodsOptions[i]}>{this.periodsOptionsLabels[i]}</MenuItem>
            )
        }
        for (let i = 0; i < this.valueToOrderOptions.length; i++) {
            this.valueToOrderItems.push(
                <MenuItem value={this.valueToOrderOptions[i]}>{this.valueToOrderOptionsLabels[i]}</MenuItem>
            )
        }

        this.setState({ loading: false, period: this.periodsOptions[0], valueToOrder: this.valueToOrderOptions[0], lifetimeRankingItems: resInitialRanking.body.sort((a, b) => b.metrics.play - a.metrics.play) })
    }

    generateRankingCard(index, pedido, shareLabelText, calculateShareFunction) {
        return <a target="_blank" href={pedido.urlBlog}>
            <Paper style={{ margin: '20px 0', display: 'flex', gap: '10px', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'center', width: '100%', padding: defaultPaperPadding }}>
                <div style={{ width: '650px', minWidth: '0', padding: '0 5px' }}>
                    <h1 style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '22px', marginBottom: this.state.client.type == blogPlayClientType ? '15px' : '0', color: palette.primary.main, fontWeight: 'bold' }}>{index + 1}. {pedido.titulo}</h1>
                    {this.state.client.type == blogPlayClientType && <span style={{ marginLeft: '5px', color: 'grey', fontSize: '18px', fontWeight: 'bold' }}>{pedido.characters} caracteres utilizados neste conteúdo</span>}
                </div>
                <div style={{ padding: '0 5px', display: 'contents', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <h1 style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '20px', marginBottom: '15px', color: palette.primary.main, fontWeight: 'bold' }}>Reproduções</h1>
                        <span style={{ marginLeft: '5px', color: 'grey', fontSize: '18px', fontWeight: 'bold' }}>{pedido.metrics.play ?? 0}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <h1 style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '20px', marginBottom: '15px', color: palette.primary.main, fontWeight: 'bold' }}>{shareLabelText}</h1>
                        <span style={{ marginLeft: '5px', color: 'grey', fontSize: '18px', fontWeight: 'bold' }}>{calculateShareFunction(pedido)}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <h1 style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '20px', marginBottom: '15px', color: palette.primary.main, fontWeight: 'bold' }}>Downloads</h1>
                        <span style={{ marginLeft: '5px', color: 'grey', fontSize: '18px', fontWeight: 'bold' }}>{pedido.metrics.download ?? 0}</span>
                    </div>
                </div>
            </Paper>
        </a>
    }

    generateRankingTable(items, dynamicShare) {
        const shareLabelText = (this.state.lastFetchedValueToOrder != null && this.state.lastFetchedValueToOrder.includes('share')) ? `Comp. ${this.state.lastFetchedValueToOrder.split('_')[1]}` : 'Comp. total'
        return <Paper style={{ padding: defaultPaperPadding }}>
            <TableContainer>
                <Table>
                    <TableHead style={{ backgroundColor: 'transparent' }}>
                        <TableRow>
                            <TableCell style={{ color: 'grey' }} align="center"></TableCell>
                            <TableCell style={{ color: 'grey' }} align="left">Postagem</TableCell>
                            <TableCell style={{ color: 'grey' }} align="center">N° de Reproduções</TableCell>
                            <TableCell style={{ color: 'grey' }} align="center">{dynamicShare ? shareLabelText : 'Comp. Total'}</TableCell>
                            <TableCell style={{ color: 'grey' }} align="center">Downloads</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.generateRankingRows(items, dynamicShare)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    }

    generateRankingRows(items, dynamicShare) {
        let rows = []

        for (let i = 0; i < items.length; i++) {
            const actualItem = items.at(i)
            let indexElement = <span>{i + 1}</span>
            // if (i < 3) {
            //     indexElement = <div style={{ position: 'relative', textAlign: 'center' }}>
            //         <img src={[goldMedalIcon, silverMedalIcon, bronzeMedalIcon][i]}></img>
            //         <span style={{ color: i == 0 ? 'grey' : 'white', fontWeight: 'bold', position: 'absolute', top: '55%', left: '50%', transform: 'translate(-50%, -50%)' }}>{i + 1}</span>
            //     </div>
            // }
            const shareData = (this.state.lastFetchedValueToOrder != null && this.state.lastFetchedValueToOrder.includes('share')) ? actualItem.metrics[this.state.lastFetchedValueToOrder] ?? 0 : actualItem.metrics.share_total ?? 0

            rows.push(
                <TableRow style={{ backgroundColor: i % 2 == 0 ? tableRowBackground : 'transparent' }}>
                    <TableCell align="center" style={{ color: 'grey', fontSize: '17px' }}>{indexElement}</TableCell>
                    <TableCell align="left" style={{ color: 'grey' }}>
                        <a target="_blank" href={actualItem.urlBlog} style={{ color: palette.primary.main, textDecoration: 'underline', textUnderlineOffset: '3px', fontSize: '17px' }}>{actualItem.titulo}</a>
                    </TableCell>
                    <TableCell align="center" style={{ color: 'grey', fontSize: '17px' }}>{actualItem.metrics.play ?? 0}</TableCell>
                    <TableCell align="center" style={{ color: 'grey', fontSize: '17px' }}>{dynamicShare ? shareData : actualItem.metrics.share_total ?? 0}</TableCell>
                    <TableCell align="center" style={{ color: 'grey', fontSize: '17px' }}>{actualItem.metrics.download ?? 0}</TableCell>
                </TableRow>
            )
        }
        return rows
    }

    generateLifetimeRankingElements(podcasts) {
        const elements = []
        for (let i = 0; i < podcasts.length; i++) {
            const pedido = podcasts[i]
            elements.push(
                this.generateRankingCard(i, pedido, 'Comp. total', (pedido) => pedido.metrics.share_total ?? 0)
            )
        }
        return elements
    }

    generateCustomRankingElements(podcasts) {
        let shareLabelText = this.state.lastFetchedValueToOrder.includes('share') ? `Comp. ${this.state.lastFetchedValueToOrder.split('_')[1]}` : 'Comp. total'

        const elements = []
        for (let i = 0; i < podcasts.length; i++) {
            const pedido = podcasts[i]
            elements.push(
                this.generateRankingCard(i, pedido, shareLabelText, (pedido) => this.state.lastFetchedValueToOrder.includes('share') ? pedido.metrics[this.state.lastFetchedValueToOrder] : pedido.metrics.share_total ?? 0)
            )
        }
        return elements
    }

    async generateRanking() {
        try {
            this.setState({ loading: true })

            const requestRanking = await request.post(url_endpoint + "playerview/getRanking/").set(authHeader()).field('period', this.state.period).field('valueToOrder', this.state.valueToOrder);

            if (requestRanking.body.length == 0) {
                this.setState({ loading: false, generalDialogTitle: 'Aviso', generalDialogMessage: 'Sem dados nos parametros', generalDialogOpen: true })
            }

            this.setState({ loading: false, lastFetchedValueToOrder: this.state.valueToOrder, customRankingItems: requestRanking.body.sort((a, b) => b.metrics[this.state.valueToOrder] - a.metrics[this.state.valueToOrder]) })
        } catch (e) {
            const msg = e.response.text
            this.setState({ loading: false, generalDialogTitle: 'Ocorreu um erro ao gerar o post', generalDialogMessage: msg, generalDialogOpen: true })
        }
    }

    render() {
        if (this.state.loading) {
            return <LoaderSpinner></LoaderSpinner>
        }
        return <div>
            <Dialog
                open={this.state.generalDialogOpen}
                onClose={() => {
                    this.setState({ generalDialogOpen: false })
                }}
            >
                <DialogTitle>
                    <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>{this.state.generalDialogTitle}</span>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <span style={{ fontSize: '14px' }}>{this.state.generalDialogMessage}</span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <span onClick={() => {
                        this.setState({ generalDialogOpen: false })
                    }} style={{ cursor: 'pointer', 'color': palette.primary.main, fontSize: '16px' }}>
                        {"OK"}
                    </span>
                </DialogActions>
            </Dialog>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                <h2 style={{ marginBottom: '10px', color: palette.primary.main }}>Top 10 conteúdos</h2>
                <InfoTooltip text='Os conteúdos do Top 10 são com base nas reproduções, e em todo o período'></InfoTooltip>
            </div>
            {this.generateRankingTable(this.state.lifetimeRankingItems, false)}
            <divider style={{ display: 'flex', margin: '20px 0', height: '2px', backgroundColor: 'lightgrey' }}></divider>
            <h2 style={{ color: palette.primary.main }}>Ranking</h2>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                        <InputLabel style={{ marginRight: '10px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '20px', color: palette.primary.main }} id="periodLabel">Período:</InputLabel>
                        <FormControl style={{ marginRight: '20px' }}>
                            <Select
                                labelId="periodLabel"
                                id="period"
                                value={this.state.period}
                                onChange={(event) => { this.setState({ period: event.target.value }) }}
                            >
                                {this.periodsItems}
                            </Select>
                        </FormControl>
                    </div>
                    <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                        <InputLabel style={{ marginRight: '10px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '20px', color: palette.primary.main }} id="valueToOrderLabel">Valor de Ordenação:</InputLabel>
                        <FormControl>
                            <Select
                                labelId="valueToOrderLabel"
                                id="valueToOrder"
                                value={this.state.valueToOrder}
                                onChange={(event) => { this.setState({ valueToOrder: event.target.value }) }}
                            >
                                {this.valueToOrderItems}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <Button onClick={() => this.generateRanking()} variant="contained" color="primary" component="span">Buscar Ranking</Button>
            </div>
            {this.state.lastFetchedValueToOrder != null && this.state.customRankingItems.length > 0 && this.generateRankingTable(this.state.customRankingItems, true)}
        </div>
    }
}

export default Ranking